import styles from '../RegulationChange.module.scss';

const { dataHigh, dataMedium, dataLow } = styles;

export const data = {
	datasets: [
		{
			data: [35, 40, 11],
			backgroundColor: [dataHigh, dataMedium, dataLow],
			borderColor: ['transparent', 'transparent', 'transparent'],
			borderWidth: 10,
		},
	],
};
export const labelData = [
	{
		id: '1',
		color: 'data-high',
		text: 'High',
		digit: '35',
	},
	{
		id: '2',
		color: 'data-medium',
		text: 'Medium',
		digit: '40',
	},
	{
		id: '3',
		color: 'data-low',
		text: 'Low',
		digit: '11',
	},
];
export const options = {
	cutout: 52,
	spacing: 1,
	responsive: true,
	maintainAspectRatio: true,
};

// data for bar
export const dataBar = {
	labels: ['SEC', 'FINRA', 'FRB', 'FDIC'],
	datasets: [
		{
			label: 'Low',
			data: [8, 4, 10, 8],
			borderColor: 'transparent',
			backgroundColor: dataLow,
		},
		{
			label: 'Medium',
			data: [6, 8, 8, 6],
			borderColor: 'transparent',
			backgroundColor: dataMedium,
		},
		{
			label: 'High',
			data: [10, 6, 4, 4],
			backgroundColor: dataHigh,
		},
	],
};
export const optionsBar = {
	scales: {
		x: {
			stacked: true,
			grid: {
				display: false,
			},
		},
		y: {
			stacked: true,
			mix: 0,
			max: 40,
			stepSize: 10,
		},
	},
	responsive: true,
	plugins: {
		legend: {
			display: false,
		},

		tooltip: {
			enabled: false,
		},
	},
};
export const menuItems = [
	{
		id: '1',
		value: 'View by: Last 6 months',
		label: 'View by: Last 6 months',
	},
	{
		id: '2',
		value: 'View by: Last 3 months',
		label: 'View by: Last 3 months',
	},

	{
		id: '3',
		value: 'View by: Last month',
		label: 'View by: Last month',
	},
	{
		id: '4',
		value: 'View by: Last week',
		label: 'View by: Last week',
	},
];
